// 数据缺省值
const DEFAULT_VALUE = "--";

export function addSign(num: number | string): string {
    let _num = num as number;
    if (typeof num === "string") {
        _num = parseFloat(num);
    }
    if (_num > 0) {
        return `+${num}`;
    } else {
        return `${num}`;
    }
}

export function formatNumber(number: any, decimal?: number, divisor?: number) {
    if (typeof number !== "number") return DEFAULT_VALUE;
    let f = "";
    if (number < 0) {
        f = "-";
        number = -number;
    }
    if (divisor) {
        number = number / divisor;
        if (number < 0.01) {
            number = 0.01;
        }
    }
    // 将数字转换为字符串
    const numStr = number.toString();

    // 分割整数部分和小数部分
    const parts = numStr.split(".");
    const integerPart = parts[0];
    let decimalPart = parts[1] || "";

    // 对整数部分进行逗号分隔
    let formattedInteger = "";
    let i;
    let j = 1;
    for (i = integerPart.length - 1, j; i >= 0; i--, j++) {
        formattedInteger = integerPart[i] + formattedInteger;
        if (j > 0 && j % 3 === 0) {
            formattedInteger = "," + formattedInteger;
        }
    }
    if (formattedInteger[0] === ",") {
        formattedInteger = formattedInteger.slice(1);
    }
    // 如果不需要格式化小数部分，直接返回整数部分
    if (!decimal) {
        return formattedInteger;
    }
    // 拼接整数部分和小数部分
    decimalPart = parseFloat("0." + (decimalPart || 0))
        .toFixed(2)
        .slice(1);
    return f + formattedInteger + decimalPart;
}
